
  import {defineComponent} from "vue";
  import SortOptionComponent from "@/components/productList/SortOptionComponent.vue";
  import ProductListComponent from "@/components/productList/ProductListComponent.vue";

  export default defineComponent({
    name: "search-result-component",
    components: {
      SortOptionComponent,
      ProductListComponent,
    },
    emits: ['load-new-item'],
    props: [
      'totalCount',
      'products',
    ],
  });
